module.exports = __webpack_public_path__ + "static/media/kaju_apple.efbeef2f.jpg";